import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from '../layout/Navbar';
import Preloader from '../layout/preloader';
import Footer from '../section-pages/footer';
import ScrollToTopBtn from '../layout/ScrollToTop';
import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`

`;

export default function Home() {
  useEffect(() => {
      if (typeof window !== 'undefined') {
          const loader = document.getElementById('mainpreloader');
          if (loader)
          setTimeout(() => {
            loader.classList.add("fadeOut");
            loader.style.display = 'none';
          }, 600)
      }
    }, []);
  return (
    <>
    {/* HEAD */}
    <Helmet>
        <link rel="icon" href="./img/icon.png" />
        <title>Fetron - Federação de Taekwondô de Rondônia</title>
    </Helmet>

    <GlobalStyles/>

    {/* LOADER */}
    <div id='mainpreloader'>
      <Preloader/>
    </div>

    {/* MENU */}
    <div className="home dark-scheme">
        <header id="header-wrap">
            <Navbar />
        </header>

        <section className="no-bg">
          <div>
              <img src="../../img/background/bg-header.png" width="100%"/>
          </div>
          <div className="container z-9">
            <div className="row align-items-center">
                <div className="col-lg-12">
                    <div className="p-5 rounded-10 bg-white-1">
                    <p>
                      A Federação de Taekwondo de Rondônia é a única entidade no estado reconhecida pela Confederação Brasileira de Taekwondo (CBTKD) e pelo Comitê Olímpico Brasileiro (COB). Responsável por organizar e fomentar o Taekwondo, nossa missão é promover o esporte como ferramenta de transformação social, inclusão e desenvolvimento.
                    </p>

                    <h5 className="mt-5">NOSSAS METAS</h5>

                    <ul>
                      <li>Difundir o Taekwondo em Rondônia.</li>
                      <li>Incentivar a participação de todos, promovendo inclusão.</li>
                                                    <li>Organizar eventos esportivos de alto nível.</li>
                      <li>Capacitar técnicos, árbitros e dirigentes.</li>
                      <li>Selecionar atletas para competições nacionais e internacionais.</li>
                    </ul>


                    <h5 className="mt-5">NOSSO PROPÓSITO</h5>

                    <li>Promover saúde, bem-estar e valores como respeito e disciplina.</li>
                    <li>Garantir inclusão social através do esporte.</li>


                    <h5 className="mt-5">QUADRO DE ÁRBITROS OFICIAIS</h5>

                    Única entidade no estado com árbitros reconhecidos pela CBTKD, assegurando excelência em eventos.


                    <h5 className="mt-5">SONHO OLÍMPICO</h5>

                    Somente por meio da Federação atletas de Rondônia podem competir em eventos como os Jogos Olímpicos, Jogos Para-olimpicos e Pan-Americanos.


                    <h5 className="mt-5">COMPROMISSO</h5>

                    Trabalhamos para formar atletas, capacitar profissionais e promover eventos que inspirem a comunidade. Participe e ajude a fortalecer o Taekwondo em Rondônia!
                    </div>
                </div>
            </div>
          </div>
        </section>

      

      {/* footer */}
      <Footer/>
    </div>
    <ScrollToTopBtn />
    </>
  )
}
